module.exports = __webpack_public_path__ + "static/brush3-e966141f9a8acec2e790bd45d02d0271.png";